// sc-options-guard.js  (exact-match + button lock)
(function () {
  function log(){ try{console.log.apply(console, ['[SC Guard]'].concat([].slice.call(arguments)));}catch(e){} }
  function firstNumberIn(str){ const m = String(str||'').match(/(\d+)\s*week/i) || String(str||'').match(/(\d+)/); return m ? parseInt(m[1],10) : 0; }
  function $(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }

  function findProductForm(){
    return document.querySelector('form[action="/cart/add"], form[action*="/cart/add"]') ||
           document.querySelector('product-form form') ||
           document.querySelector('form[method="post"][data-type="add-to-cart-form"]');
  }
  function findAddToCartButtons(form){
    // common selectors across themes/apps
    const btns = $('button[name="add"], button[type="submit"], .product-form__submit, [data-add-to-cart]', form || document);
    // de-dupe
    return Array.from(new Set(btns));
  }
  function findWeeksSelect(){
    const selects = $('select');
    for (const sel of selects) {
      const texts = Array.from(sel.options||[]).map(o=>o.text.toLowerCase());
      if (texts.some(t => /\b\d+\s*week/.test(t))) return sel;
    }
    return null;
  }
  function findWeekCheckboxes(){
    const cbs = $('input[type="checkbox"]');
    const weekCbs = cbs.filter(cb => {
      const lbl = cb.closest('label');
      const txt = (lbl ? lbl.innerText : '').toLowerCase();
      return /\bweek\s*[-(]/.test(txt) || /\bweek\s+\d+/.test(txt);
    });
    return weekCbs.length >= 2 ? weekCbs : [];
  }

  function wireUp(){
    if (window.__scGuardWired) return false;
    const form = findProductForm();
    const weeksSelect = findWeeksSelect();
    const weekCheckboxes = findWeekCheckboxes();
    if (!form || !weeksSelect || weekCheckboxes.length === 0) return false;

    window.__scGuardWired = true;
    log('wired');

    const addButtons = findAddToCartButtons(form);

    // Message under the checkbox group
    const groupContainer =
      weekCheckboxes[0].closest('.sc-option, .product-option, .sco, .option, fieldset') ||
      weekCheckboxes[0].closest('div') || form;
    const msg = document.createElement('div');
    msg.className = 'sc-guard-msg';
    msg.style.marginTop = '6px';
    msg.style.fontSize = '0.95rem';
    msg.style.color = '#b00020';
    groupContainer.appendChild(msg);

    function requiredCount(){
      const opt = weeksSelect.options && weeksSelect.options[weeksSelect.selectedIndex];
      return firstNumberIn(opt ? opt.text : weeksSelect.textContent);
    }
    function getWeekCbs(){ return findWeekCheckboxes(); } // re-query in case app re-renders
    function selectedCount(){ return getWeekCbs().filter(cb=>cb.checked).length; }

    function setButtonsEnabled(enabled){
      addButtons.forEach(btn => {
        btn.disabled = !enabled;
        btn.setAttribute('aria-disabled', String(!enabled));
        if (!enabled) btn.classList.add('is-disabled'); else btn.classList.remove('is-disabled');
      });
    }

    function enforceMax(max){
      const weekCbs = getWeekCbs();
      let checked = weekCbs.filter(cb => cb.checked);

      // If too many are checked, uncheck extras (keep the first N user picked)
      if (max && checked.length > max) {
        checked.slice(max).forEach(cb => cb.checked = false);
        checked = weekCbs.filter(cb => cb.checked);
      }

      // Disable remaining once max reached; otherwise keep them enabled
      weekCbs.forEach(cb => {
        if (max && checked.length >= max && !cb.checked) {
          cb.disabled = true;
          cb.closest('label') && (cb.closest('label').style.opacity = '0.5');
        } else {
          cb.disabled = false;
          cb.closest('label') && (cb.closest('label').style.opacity = '');
        }
      });
    }

    function updateMessage(ok){
      const req = requiredCount();
      const sel = selectedCount();
      if (!req) { msg.textContent = ''; return; }
      msg.textContent = ok ? '' : `Select exactly ${req} week${req===1?'':'s'} (currently selected: ${sel}).`;
    }

    function validate(){
      const ok = !requiredCount() || selectedCount() === requiredCount();
      updateMessage(ok);
      setButtonsEnabled(ok);      // <-- lock/unlock Add to Cart
      return ok;
    }

    function refresh(){
      enforceMax(requiredCount());
      validate();
    }

    // Events
    weeksSelect.addEventListener('change', refresh);
    getWeekCbs().forEach(cb => cb.addEventListener('change', refresh));

    // Block add-to-cart as a safety net (for themes that ignore disabled)
    form.addEventListener('submit', function(e){
      if (!validate()){
        e.preventDefault();
        msg.scrollIntoView({behavior:'smooth', block:'center'});
      }
    });
    // Also intercept direct button clicks (AJAX carts sometimes bypass form submit)
    findAddToCartButtons(form).forEach(btn => {
      btn.addEventListener('click', function(e){
        if (!validate()){
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });

    // Initial pass
    refresh();
    return true;
  }

  function tryWire(){ wireUp(); }

  const obs = new MutationObserver(function(){
    if (!window.__scGuardWired) tryWire();
  });
  obs.observe(document.documentElement, {childList: true, subtree: true});

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryWire);
  } else {
    tryWire();
  }
})();